module.exports = __webpack_public_path__ + "img/img11.b72d2b66.svg";